module.exports = __webpack_public_path__ + "static/media/dentalcrown.0970f39c.png";